module.exports = __webpack_public_path__ + "static/media/erroWpp.88f606b2.jpeg";